import { render } from "./PagesEdit.vue?vue&type=template&id=2b6a6222&scoped=true"
import script from "./PagesEdit.vue?vue&type=script&lang=js"
export * from "./PagesEdit.vue?vue&type=script&lang=js"

import "./PagesEdit.vue?vue&type=style&index=0&id=2b6a6222&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6a6222"]])

export default __exports__